const Image = ({ _attributes, element, children }) => {
  const { url, alt } = element;
  // const selected = useSelected();
  // const focused = useFocused();
  // const editor = useSlate();
  // const updateNode = (size) => {
  //   //get the current node
  //   const parentPath = Path.parent(editor.selection.focus.path);
  //   const parentNode = Node.get(editor, parentPath);
  //   //update the node
  //   const newElement = {
  //     ...parentNode,
  //     width: size.width
  //   };
  //   //replace the node
  //   Transforms.setNodes(editor, newElement, { at: parentPath });
  // };
  // const [size, onMouseDown, resizing] = useResize(updateNode);

  return (
    <div className=' direction-ltr'>
      <div className='w-full'>
        {/* <div
        {...attributes}
        className='max-w-full embed'
        style={{ display: 'flex', boxShadow: selected && focused && '0 0 3px 3px lightgray', width: `${resizing ? size.width : element.width}px` }}
        {...element.attr}> */}
        <div contentEditable={false} className='w-full'>
          {/* <div contentEditable={false} style={{ width: `${resizing ? size.width : element.width}px`, maxWidth: '100%' }}> */}
          <img alt={alt} src={url} className='object-fill w-full h-full ' />
          {/* {selected && (
            <button className='absolute p-1 border opacity-100 rounded-xl border-t-border-color-base bg-t-bg-color bottom-1 left-1' onMouseDown={onMouseDown}>
              <Icon icon='resize' />
            </button>
          )} */}
        </div>
        {children}
      </div>
    </div>
  );
};
export default Image;
